// @flow
import experiments from 'app/common/lib/experiments';
import PageVisibility from 'app/packages/page-visibility';
import { setCachingStrategy } from 'app/packages/trace-logger/resourceTiming';
import {
  stopTiming,
  abortTiming,
  logCustomTraceEvent,
} from 'app/common/lib/TraceLogger/logTraceEvent';

const shouldAbortOnBlur = () =>
  (
    experiments.getInstance().v2ActivateExperiment('web_tracelogger_abort_on_blur') || ''
  ).startsWith('enabled');

export default function registerPageLoadEventListeners(upwtActionName: string) {
  /**
   * If we call _onLoadHandler right on onLoad window event
   * window.performance.timing['loadEventEnd'] will be 0. We have to wait until
   * onLoad event will finish completely
   */
  function handleOnLoad() {
    let timeoutId = null;
    if (window.performance.timing.loadEventEnd > 0) {
      logCustomTraceEvent({ name: 'PageLoadRegisterGridItemsPositionedTraceEvent' });
      stopTiming(upwtActionName);
      clearTimeout(timeoutId);
    } else {
      timeoutId = setTimeout(handleOnLoad.bind(this), 1000);
    }
  }
  window.addEventListener('load', handleOnLoad);

  setCachingStrategy({
    custom: (
      experiments.getInstance().v2ActivateExperiment('web_tracelogger_resource_buffer') || ''
    ).startsWith('enabled'),
    size: 400, // 0.5 KB / entry * 400 entires ~= 200 KB
  });

  if (shouldAbortOnBlur()) {
    PageVisibility.onSessionPause((isUnload) => {
      abortTiming(isUnload ? 'beforeunload' : 'blur');
    });
  } else {
    window.addEventListener('beforeunload', () => {
      abortTiming('beforeunload');
    });
  }

  window.addEventListener('popstate', () => {
    abortTiming('popstate');
  });

  window.perfMetrics.onFirstInputDelay((delay, evt) => {
    // In some browsers `event.timeStamp` returns a `DOMTimeStamp` value
    // (epoch time) istead of the newer `DOMHighResTimeStamp`
    // (document-origin time). To check for that we assume any timestamp
    // greater than 1 trillion is a `DOMTimeStamp`. If it's not a DOMTimeStamp
    // then we convert it to epoch time by adding the document origin time.
    const isEpochTime = evt.timeStamp > 1e12;
    if (isEpochTime) {
      window.performance.timing.firstInputDelayStart = evt.timeStamp;
    } else {
      window.performance.timing.firstInputDelayStart =
        evt.timeStamp + window.performance.timing.navigationStart;
    }
    window.performance.timing.firstInputDelayEnd =
      window.performance.timing.firstInputDelayStart + delay;
    window.performance.timing.firstInputDelay = delay;
  });
}
